import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const total = testimonials.length;
  const t = testimonials[idx];

  const go = (dir) => setIdx((p) => (p + dir + total) % total);

  return (
    <section id="testimonios" className="py-24 lg:py-32 bg-[#2D3A2D] text-[#F4EDE2] relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, #D4A595 0%, transparent 60%)",
        }}
      />

      <div className="max-w-[1100px] mx-auto px-6 lg:px-12 relative">
        <div className="flex items-center gap-3 mb-5 text-[#D4B5A6]">
          <span className="inline-block w-9 h-px bg-[#D4B5A6]" />
          <span className="text-[12px] tracking-[0.28em] uppercase">
            Lo que dicen mis pacientes
          </span>
        </div>
        <h2 className="font-serif text-[36px] lg:text-[50px] leading-[1.05] tracking-[-0.02em] max-w-[700px]">
          Procesos reales,
          <span className="italic text-[#D4B5A6]"> palabras propias.</span>
        </h2>

        <div className="mt-14 relative">
          <Quote
            size={64}
            strokeWidth={1}
            className="absolute -top-2 -left-2 text-[#B8806E]/40"
          />
          <p
            key={idx}
            className="relative font-serif text-[24px] lg:text-[32px] leading-[1.45] italic text-[#F4EDE2]/95 fade-up"
          >
            “{t.text}”
          </p>

          <div className="mt-10 flex items-center justify-between flex-wrap gap-6">
            <div>
              <p className="font-serif text-[22px] text-[#D4B5A6]">{t.name}</p>
              <p className="text-[12px] tracking-[0.22em] uppercase text-[#F4EDE2]/55 mt-1">
                {t.role}
              </p>
            </div>

            <div className="flex items-center gap-3">
              <button
                aria-label="Anterior"
                onClick={() => go(-1)}
                className="w-12 h-12 rounded-full border border-[#F4EDE2]/30 grid place-items-center hover:bg-[#F4EDE2] hover:text-[#2E2A23] transition-colors duration-300"
              >
                <ChevronLeft size={18} strokeWidth={1.5} />
              </button>
              <span className="text-[13px] tracking-[0.18em] text-[#F4EDE2]/70 min-w-[60px] text-center">
                0{idx + 1} / 0{total}
              </span>
              <button
                aria-label="Siguiente"
                onClick={() => go(1)}
                className="w-12 h-12 rounded-full border border-[#F4EDE2]/30 grid place-items-center hover:bg-[#F4EDE2] hover:text-[#2E2A23] transition-colors duration-300"
              >
                <ChevronRight size={18} strokeWidth={1.5} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
